import { render, staticRenderFns } from "./specialDetail.vue?vue&type=template&id=02a0ae8f&scoped=true&"
import script from "./specialDetail.vue?vue&type=script&lang=js&"
export * from "./specialDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialDetail.vue?vue&type=style&index=0&id=02a0ae8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a0ae8f",
  null
  
)

export default component.exports